<template>
    <div>
        <!--    Buyflow - Internet - Service Selection Was Not Available    -->
        <div v-if="!selectedOfferIsAvailable && !changedService"
             class="buyflow-panel
                    border-4
                    border-yellow-200
                    bg-yellow-50
                    text-navy-dark
                    text-center">
            <div class="font-bold
                        text-lg tablet:text-xl
                        mb-2">
                The offer you selected is not available in your area
            </div>
            <p class="text-sm">
                We've pre-populated your cart with a comparable internet service package available to you.
                You can select the speed that meets your need from the ones available below.
            </p>
        </div>

        <!--    Buyflow - Internet - Services Section    -->
        <InternetServices :is-minimal="isMinimal"
                          :services="services"
                          :get-service-price="getServicePrice"
                          :other-services="otherServices"
                          :selected-service="selectedService"
                          :market-type="marketType"
                          :offerId="offerId"
                          @select-options="selectInternetOptions($event)"
                          @changed-selected-service="changedSelectedService" />

        <!--    Buyflow - Internet - Equipment Section    -->
        <InternetEquipments :is-minimal="isMinimal"
                            :market-type="marketType"
                            :extra-pods-in-cart="extraPodsInCart"
                            :extra-pods-data="podOrExtender"
                            :is-equipment-selected="isEquipmentSelected"
                            :selected-internet="selectedService"
                            :modem-options="modemOptions"
                            :wyw-options="wywOptions"
                            @select-options="selectInternetOptions($event)" />

        <!--    Buyflow - Internet - Mobile Callout    -->
        <InternetMobileCallout />
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import InternetServices from '~/Buyflow/components/InternetServices'
    import InternetEquipments from '~/Buyflow/components/InternetEquipments'
    import InternetMobileCallout from '~/Buyflow/components/InternetMobileCallout'
    import {captureException} from "@sentry/browser";

    export default {
        name: 'InternetPage',
        components: {
            InternetServices,
            InternetEquipments,
            InternetMobileCallout
        },
        data: () => ({
            changedService: false,
        }),
        computed: {
            ...mapState({
                uuid: state => state.meta.uuid,
                marketType: state => state.meta.marketType,
                offerId: state => state.meta.offerId,
                currentStep: state => state.Buyflow.currentStep,
                services: state => state.Buyflow.internet.data.services,
                selectedOfferIsAvailable: state => state.selectedOfferIsAvailable,
                wywOptions: state => state.Buyflow.internet.data.equipments.wywOptions,
                modemOptions: state => state.Buyflow.internet.data.equipments.modemOptions,
            }),
            ...mapGetters({
                isHidden: 'Buyflow/internet/isHidden',
                isMinimal: 'Buyflow/internet/isMinimal',
                otherServices: 'Buyflow/internet/otherServices',
                extraPodsInCart: 'Buyflow/internet/extraPodsInCart',
                selectedService: 'Buyflow/internet/selectedService',
                getServicePrice: 'Buyflow/internet/getServicePrice',
                isEquipmentSelected: 'Buyflow/internet/isEquipmentSelected',
                podOrExtender: 'Buyflow/internet/podOrExtender',
            }),
        },
        mounted() {
            if(this.currentStep < 1) {
                this.sendEvent('resi: serviceable lead', 'resi: selected service',  `resi: customer uuid - ${this.uuid}`)
            }

            this.pushEvent('begin_checkout', {
                'currency': 'USD',
                'items': [
                    {
                        'item_id': `${this.selectedService?.name.replace(/\s/g, '')}-${this.selectedService?.speed?.download}`,
                        'item_name': this.selectedService?.name,
                        'item_category': 'internet',
                        'item_brand': 'Breezeline Online',
                        'item_category2': this.selectedService?.speed?.download,
                        'item_list_name': 'internet list',
                        'item_variant': this.selectedService?.name,
                        'price': this.getServicePrice(this.selectedService).toFixed(2),
                        'quantity': '1'
                    }
                ],
                'flow_step_name': 'choose internet and wifi options',
                'flow_step_number': '1'
            });

            this.setSessionStatus({ session_status: 1, })
            this.setCurrentStep([1,'internet page'])
            if (this.isHidden){
                this.$router.push({ name: 'buyflow-tv' })
            }

            // Pending label requests
            let pendingGroup = this.$store.state.BroadbandLabels.pendingLabelRequestGroup;

            if (pendingGroup && Array.isArray(pendingGroup) && pendingGroup.length > 0) {
                // Process requests
                this.$store.dispatch('BroadbandLabels/processPendingLabelRequests').then(() => {
                   console.log('processed pending requests')
                })
            }
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'Buyflow/setCurrentStep',
                setSessionStatus: 'Buyflow/setSessionStatus',
                selectInternetOptions: 'Buyflow/internet/selectInternetOptions',
                setMeta: 'setMeta' 
            }),
            changedSelectedService() {
                this.changedService = true;
            }
        },
    }
</script>
